// Shared display formatters.

// Render a SQLite UTC timestamp ("YYYY-MM-DD HH:MM:SS") as a short local
// date/time, e.g. "Jun 30, 02:30 PM". Returns the raw value if unparseable.
export function fmtTimestamp(ts: string | null | undefined): string {
  if (!ts) return '';
  const d = new Date(ts.replace(' ', 'T') + 'Z');
  if (isNaN(d.getTime())) return ts;
  return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }).format(d);
}

// Format a number as whole-dollar USD, e.g. 6500 → "$6,500".
export function money(n: number | null | undefined): string {
  const v = Number(n) || 0;
  return `$${v.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
}
